(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CopyrightDeleteController',CopyrightDeleteController);

    CopyrightDeleteController.$inject = ['$uibModalInstance', 'entity', 'Copyright'];

    function CopyrightDeleteController($uibModalInstance, entity, Copyright) {
        var vm = this;

        vm.copyright = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Copyright.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
